angular
	.module('transactionTable.components', ['app.services'])
	.component('transactionTable', {
		templateUrl: 'ng/components/transactionTable/transactionTable.view.html',
		controllerAs: 'TransactionTableCtrl',
		bindings: {
			identifierAppCustomer: '='

		},
		controller: function (
			$rootScope,
			$searchUserService,
			$configService,
			$instantService,
			$transactionFactory,
			$location,
			$instantLeasingService,
			InstantModel,
			$window,
			$contractService
		) {

			var self = this;
			self.searchUserService = $searchUserService;
			self.configService = $configService;

			$rootScope.$on("refreshListAppContract", function (event, args) {
				console.log("BROADCAST CALL - refreshListAppContract - self.getListTransactionWorks=" + self.getListTransactionWorks);
				if (!self.getListTransactionWorks) {
					self.getListTransactionWorks = true;
					getListTransaction(args.identifierAppCustomer);
				}

			});

			self.propMap = propMap;

			self.$onInit = function () {
				self.selectedContract = null;
				self.loader = [];
				self.loaderFirma = [];
				self.mapTransactionStatus = {};
				self.errorePratica = "É presente un errore nella pratica, si prega di correggerla!";
				/** check if URL contain infocertRedirect 
				 * if true will call the rest 
				 * for update transaction  
				 */
				var url = $location.absUrl();
				if (url.indexOf("infocertRedirect") > 1) {
					/**
					 * Da decidere come far visualizzare il loader sia quando si attende la risposta del rest getListIlTransaction
					 * sia quando si attende la risposta del rest di update delle informazioni della singola transazione.
					 * Oppure nel secondo caso far comparire il loader di pagina come compare nelle altre situazioni di attesa
					 */
					// $rootScope.$broadcast("pageLoader", {
					// 	action: "OPEN"
					// });
					var input = url.split('infocertRedirect=')[1];
					$contractService.updateSignedDossier(input)
						.then(function (response) {
							// $rootScope.$broadcast("pageLoader", {
							// 	action: "CLOSE"
							// });
							getListTransaction();

						})
						.catch(function (error) {
							// $rootScope.$broadcast("pageLoader", {
							// 	action: "CLOSE"
							// });
						})
				} else {
					getListTransaction();
				}
			}

			self.filter = {
				appIlTransaction: {
					limit: '5',
					offset: 0,
					pageIndex: 1,
					totalPages: 0,
					orderColumnName: 'UPDATE_DATE',
					orderType: 'DESC',
					cfCustomer: $configService.getUser().identifier,
					status: '',
					piva: ''
				}
			};


			var getListTransaction = function () {

				$instantService.getListIlTransaction(self.filter)
					.then(function (response) {
						console.log('Risposta dal servizio: ', response)
						self.listAppIlTransaction = response.listAppIlTransaction;
						self.filter.appIlTransaction.totalPages = getSTotalPages(response.listAppIlTransactionCount);
						self.getListIlTransactionFinish = true;
					})
					.catch(function (error) {
						console.log("Errore risposta: ", error);
						self.getListIlTransactionFinish = true;
					})
			}

			//update table getAllSimulations
			self.updateOrderTableSimulation = function (ordColName, ordType) {
				self.filter.appIlTransaction.orderColumnName = ordColName;
				self.filter.appIlTransaction.orderType = ordType;
				getListTransaction();

			}

			self.pageSIndexIndietro = function (value) {
				if (value == 'init') {
					self.filter.appIlTransaction.pageIndex = 1;
				} else {
					if (self.filter.appIlTransaction.pageIndex > 1) {
						self.filter.appIlTransaction.pageIndex--;
					}
				}
				updateOffsetAndSearch();
			}

			self.pageSIndexAvanti = function (value) {
				if (value == 'end') {
					//subito pagina finale
					self.filter.appIlTransaction.pageIndex = self.filter.appIlTransaction.totalPages;
				} else {
					//avanzo +1
					if (self.filter.appIlTransaction.pageIndex < self.filter.appIlTransaction.totalPages) {
						self.filter.appIlTransaction.pageIndex++;
					}
				}
				updateOffsetAndSearch();
			}

			function updateOffsetAndSearch() {
				self.filter.appIlTransaction.offset = (self.filter.appIlTransaction.pageIndex - 1) * self.filter.appIlTransaction.limit;
				getListTransaction();
			}

			function getSTotalPages(totalCount) {
				//se il resto è zero non va aggiunto +1
				var addPlusOneToTotal = 0;
				var totModuloResult = totalCount % Number(self.filter.appIlTransaction.limit);
				if (totModuloResult > 0) {
					addPlusOneToTotal = 1;
				}
				return (Math.floor(totalCount / Number(self.filter.appIlTransaction.limit))) + addPlusOneToTotal;
			}

			// PAGINATION END

			self.goToInstantLeasing = function (index) {
				if (!self.listAppIlTransaction[index].idWfInstance) {
					console.error("Error! The transaction you picked has no idWfInstance, we can't resume it!", self.listAppIlTransaction[index]);
					return;
				}
				self.loader[index] = true;
				$instantLeasingService.resumeInstance(self.listAppIlTransaction[index].idWfInstance)
					.then(function (response) {
						console.log('La risposta della chiamata: ', response);
						response.idWfInstance = self.listAppIlTransaction[index].idWfInstance;
						$transactionFactory.set(InstantModel.build(response));
						console.log(self.loader[index]);
						$location.path("/instantLeasing");

					})
					.catch(function (err) {
						console.log('La chiamata è andata in errore: ', err);
					})
					.finally(function () {
						self.loader[index] = false;
					})

			}


			self.goToPracticeDetail = function (index) {
				self.loader[index] = true;
				$instantLeasingService.getPracticeDetail(self.listAppIlTransaction[index].idWfInstance)
					.then(function (response) {
						console.log('La risposta della chiamata: ', response);
						response.idWfInstance = self.listAppIlTransaction[index].idWfInstance;
						$transactionFactory.set(InstantModel.build(response));
						console.log(self.loader[index]);
						$location.path("/practiceDetail");

					})
					.catch(function (err) {
						console.log('La chiamata è andata in errore: ', err);
					})
					.finally(function () {
						self.loader[index] = false;
					})

			}


			self.goToBeCorrected = function (index) {
				self.loader[index] = true;
				$instantService.getErrorMessageContractByIdTransaction(self.listAppIlTransaction[index].idWfInstance)
					.then(function (response) {
						response.appContract.idWfInstance = self.listAppIlTransaction[index].idWfInstance;
						response.appContract.typeWf = self.listAppIlTransaction[index].type;
						$transactionFactory.set(response.appContract);
						$location.path("/toBeCorrected")

					})
					.catch(function (err) {
						console.log('La chiamata è andata in errore: ', err);
					})
					.finally(function () {
						self.loader[index] = false;
					})

			}

			self.getDossierUrl = function (dossierId, index) {
				self.loaderFirma[index] = true;
				$contractService.getDossierUrl(dossierId)
					.then(function (response) {
						if (response.success) {
							var url = response.dossierUrl;
							$window.open(url, '_self');
						}
						self.loaderFirma[index] = false;
					})
					.catch(function (error) {
						console.log(error);
						self.loaderFirma[index] = false;
					})
			}


		}
	});